if (document.querySelector('.bannerSwiper') && typeof window.Swiper === 'function') {
        new window.Swiper(".bannerSwiper", {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: false,
          autoHeight: true,
          autoplay: {
              delay: 5000,
              disableOnInteraction: false,
          },
          speed: 500,
          pagination: {
              el: ".top-pagination",
              clickable: true,
          },
          navigation: {
              nextEl: ".top-button-next",
              prevEl: ".top-button-prev",
          },
      });
      }
